"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _once = _interopRequireDefault(require("playbooks-modal/utils/once"));

var _EngagementTypes = require("customer-data-objects/engagement/EngagementTypes");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _PlaybooksModalFooterSelectCallDisposition = _interopRequireDefault(require("./PlaybooksModalFooterSelectCallDisposition"));

var _PlaybooksModalFooterSelectActivityType = _interopRequireDefault(require("./PlaybooksModalFooterSelectActivityType"));

var _SaveStatus = _interopRequireDefault(require("./SaveStatus"));

var getEngagementTypeOptions = (0, _once.default)(function () {
  return [{
    text: _I18n.default.text('playbooksModal.footer.engagementTypes.saveAsNote'),
    value: _EngagementTypes.NOTE
  }, {
    text: _I18n.default.text('playbooksModal.footer.engagementTypes.logACall'),
    value: _EngagementTypes.CALL
  }, {
    text: _I18n.default.text('playbooksModal.footer.engagementTypes.logAnEmail'),
    value: _EngagementTypes.EMAIL
  }, {
    text: _I18n.default.text('playbooksModal.footer.engagementTypes.logAMeeting'),
    value: _EngagementTypes.MEETING
  }];
});

var PlaybooksFooterButtons = function PlaybooksFooterButtons(_ref) {
  var buttonSize = _ref.buttonSize,
      showSaveButton = _ref.showSaveButton,
      showCloseButton = _ref.showCloseButton,
      hasActivityTypes = _ref.hasActivityTypes,
      engagementType = _ref.engagementType,
      activityType = _ref.activityType,
      callDisposition = _ref.callDisposition,
      callDispositions = _ref.callDispositions,
      activityTypeOptions = _ref.activityTypeOptions,
      useLogButton = _ref.useLogButton,
      autoSaveStatus = _ref.autoSaveStatus,
      onEngagementTypeChange = _ref.onEngagementTypeChange,
      onCallDispositionChange = _ref.onCallDispositionChange,
      onActivityTypeChange = _ref.onActivityTypeChange,
      onSave = _ref.onSave,
      onClose = _ref.onClose;

  if (!showSaveButton) {
    return _react.default.createElement(_UIButton.default, {
      use: "primary",
      size: buttonSize,
      onClick: onClose,
      "data-selenium-test": "playbooks-modal-close-button"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "playbooksModal.footer.buttons.close"
    }));
  }

  var logButtonCopy = !useLogButton ? 'playbooksModal.footer.buttons.save' : "playbooksModal.footer.buttons.log." + engagementType;
  return _react.default.createElement(_UIFlex.default, {
    align: "center",
    className: "playbooks-modal-footer-buttons"
  }, _react.default.createElement(_UIButton.default, {
    size: buttonSize,
    use: "primary",
    onClick: onSave,
    "data-selenium-test": "save-playbook"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: logButtonCopy
  })), showCloseButton && _react.default.createElement(_UIButton.default, {
    size: buttonSize,
    use: "secondary",
    onClick: onClose,
    className: "m-right-4"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "playbooksModal.footer.buttons.close"
  })), !useLogButton && _react.default.createElement(_UISelect.default, {
    buttonUse: "transparent",
    buttonSize: buttonSize,
    searchable: false,
    onChange: function onChange(e) {
      return onEngagementTypeChange(e.target.value);
    },
    options: getEngagementTypeOptions(),
    value: engagementType
  }), _react.default.createElement(_PlaybooksModalFooterSelectCallDisposition.default, {
    buttonSize: buttonSize,
    engagementType: engagementType,
    callDisposition: callDisposition,
    callDispositions: callDispositions,
    onCallDispositionChange: onCallDispositionChange
  }), _react.default.createElement(_PlaybooksModalFooterSelectActivityType.default, {
    buttonSize: buttonSize,
    hasActivityTypes: hasActivityTypes,
    engagementType: engagementType,
    activityType: activityType,
    activityTypeOptions: activityTypeOptions,
    onActivityTypeChange: onActivityTypeChange
  }), autoSaveStatus && _react.default.createElement(_SaveStatus.default, {
    status: autoSaveStatus,
    className: "m-left-auto"
  }));
};

PlaybooksFooterButtons.propTypes = {
  buttonSize: _UIButton.default.propTypes.size,
  showSaveButton: _react.PropTypes.bool.isRequired,
  showCloseButton: _react.PropTypes.bool,
  hasActivityTypes: _react.PropTypes.bool.isRequired,
  engagementType: _react.PropTypes.string,
  activityType: _react.PropTypes.string,
  callDisposition: _react.PropTypes.string,
  callDispositions: _react.PropTypes.instanceOf(_immutable.OrderedMap).isRequired,
  activityTypeOptions: _react.PropTypes.array.isRequired,
  useLogButton: _react.PropTypes.bool.isRequired,
  autoSaveStatus: _react.PropTypes.string,
  onSave: _react.PropTypes.func.isRequired,
  onEngagementTypeChange: _react.PropTypes.func.isRequired,
  onCallDispositionChange: _react.PropTypes.func.isRequired,
  onActivityTypeChange: _react.PropTypes.func.isRequired,
  onClose: _react.PropTypes.func.isRequired
};
PlaybooksFooterButtons.defaultProps = {
  showCloseButton: true,
  useLogButton: false
};
var _default = PlaybooksFooterButtons;
exports.default = _default;
module.exports = exports.default;